import type { AlertRow } from '../types';

interface Props {
  alerts: AlertRow[];
}

const SEVERITY_ICON: Record<string, string> = {
  info: 'ℹ️',
  warn: '⚠️',
  critical: '🚨',
};

function formatUtc(unixTs: number): string {
  const d = new Date(unixTs * 1000);
  return d.toISOString().replace('T', ' ').replace(/\.\d{3}Z$/, ' UTC');
}

function durationLabel(triggered: number, resolved: number): string {
  const secs = resolved - triggered;
  if (secs < 60) return `${secs}s`;
  const mins = Math.floor(secs / 60);
  if (mins < 60) return `${mins}m`;
  const hours = Math.floor(mins / 60);
  const remMin = mins % 60;
  return `${hours}h${remMin}m`;
}

export function AlertList({ alerts }: Props) {
  if (alerts.length === 0) {
    return (
      <section className="alert-list empty" aria-label="alert-history">
        <h2>告警歷史</h2>
        <p className="muted">尚無告警紀錄。</p>
      </section>
    );
  }

  return (
    <section className="alert-list" aria-label="alert-history">
      <h2>告警歷史(近 {alerts.length} 筆)</h2>
      <ul>
        {alerts.map((a) => (
          <li key={a.id} className={`alert-row severity-${a.severity}`}>
            <div className="alert-head">
              <span className="alert-icon">{SEVERITY_ICON[a.severity] ?? '•'}</span>
              <span className="alert-type">{a.alert_type}</span>
              <span className="alert-severity">{a.severity.toUpperCase()}</span>
            </div>
            <div className="alert-message">{a.message}</div>
            <div className="alert-meta">
              <span>觸發:{formatUtc(a.triggered_at)}</span>
              {a.resolved_at ? (
                <span>
                  已解除:{formatUtc(a.resolved_at)}{' '}
                  <em>({durationLabel(a.triggered_at, a.resolved_at)})</em>
                </span>
              ) : (
                <span className="active-indicator">⚡ 未解除 (active)</span>
              )}
            </div>
          </li>
        ))}
      </ul>
    </section>
  );
}
